import React from "react";
import { Button } from "./Button";
import "./CardServices.css";
import { Link } from "react-router-dom";

function CardServices() {
  return (
    <div className="services-home-page">
      <h1>Real Estate Media Production Services</h1>
      <br></br>
      <div className="services-link">
        <Link>
          <h3>360° Virtual Walkthroughs</h3>
          <p>
            Offer immersive, anytime access that builds trust and drives faster
            decision-making.
          </p>
        </Link>
        <Link>
          <h3>Immersive Aerial Drone Footage</h3>
          <p>
            Highlight location, scale, and lifestyle from above, giving buyers
            the full picture in one glance.
          </p>
        </Link>
        <Link>
          <h3>Cinematic Video Tours</h3>
          <p>
            Engage prospects emotionally with cinematic property films that
            increase time spent on your listings.
          </p>
        </Link>
        <Link>
          <h3>Real Estate Photography</h3>
          <p>
            Make your listings stand out with crisp, elegant images that capture
            buyer attention instantly.
          </p>
        </Link>
      </div>

      <div className="buttons">
        <Link to="/services">
          <Button
            className="btn-mobile"
            buttonStyle="btn--outline"
            buttonSize="btn--large"
          >
            Explore Services
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default CardServices;
